import FeedbackData from '../../store/viewSchema/FeedbackData';
import removeDuplicatesFromUserVoiceData from './removeDuplicatesFromUserVoiceData';
import { TxpObject } from 'txp-data';

export default function getFeedbackData(txpObject: TxpObject): FeedbackData {
    let { txpEntities } = txpObject;
    if (txpEntities) {
        let entityTrustLevels: string[] = Object.values(txpEntities).map(
            entity => entity.trustScore
        );
        let entityTrustLevel = removeDuplicatesFromUserVoiceData(entityTrustLevels);

        let entityExtractionSources: string[] = Object.values(txpEntities).map(
            entity => entity.source
        );
        let entityExtractionSource = removeDuplicatesFromUserVoiceData(entityExtractionSources);

        let entitiesNames: string[] = Object.values(txpEntities).map(entity => entity.entityName);
        let entitiesNamesMap = removeDuplicatesFromUserVoiceData(entitiesNames);

        let originalEmailEwsId: string = Object.values(txpEntities).map(
            entity => entity.originalEmailEwsId
        )[0];

        let originalEmailReceivedTime: string = Object.values(txpEntities).map(
            entity => entity.originalEmailReceivedTime
        )[0];

        return {
            TXP_EntityTrustLevel: entityTrustLevel,
            TXP_EntityExtractionSource: entityExtractionSource,
            TXP_EntityNamesMap: entitiesNamesMap,
            TXP_OriginalEmailEwsId: originalEmailEwsId,
            TXP_OriginalEmailReceivedTime: originalEmailReceivedTime,
        } as FeedbackData;
    } else {
        return null;
    }
}
